// extracted by mini-css-extract-plugin
export default {"container":"dND8_o","flag-container":"kjcPLb","flagContainer":"kjcPLb","placeholder":"DwoSCE"};